/**
 * 送金先 (受取口座など) の表示。
 *
 * 精算画面で「この人にどこへ送ればいいか」をその場で示すためのもの。
 * 口座番号を口頭やチャットで聞く手間をなくすのが目的なので、
 * ワンタップでコピーできるようにしている。
 */
import { formatPayoutAccount } from "@spli/app-logic";
import { PAYOUT_ACCOUNT_KIND_LABELS, type PayoutAccountDto } from "@spli/core";
import { useState } from "react";

export function PayoutAccountView({ account }: { account: PayoutAccountDto }) {
  const [copied, setCopied] = useState(false);
  const text = formatPayoutAccount(account);

  const copy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // クリップボードが使えない環境では表示だけで足りる
    }
  };

  return (
    <div className="payout">
      <div className="row" style={{ justifyContent: "space-between" }}>
        <span className="muted">送金先 ({PAYOUT_ACCOUNT_KIND_LABELS[account.kind]})</span>
        <button type="button" className="button button--ghost button--small" onClick={copy}>
          {copied ? "コピーしました" : "コピー"}
        </button>
      </div>
      <div className="payout__value">{text}</div>
      {account.note && <div className="muted">{account.note}</div>}
    </div>
  );
}
